import React from "react";
import Linkify from "react-linkify";
import ChatWidget from "./ChatWidget";
import ChatWidgetOutside from "./ChatWidgetOutside";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import CTE from "../Constants";
import { FacebookEmbed } from "react-social-media-embed";

function Avatar(props) {
    if (props.isAgentMessage) {
        if (props.styles && props.styles.avatar && props.styles.avatar.url) {
            return (
                <img
                    src={props.styles.avatar.url}
                    alt="avatar"
                    className="chat-optiwe__avatar"
                    style={props.styles.avatar.styles}
                />
            );
        } else {
            return <FontAwesomeIcon icon={faUserCircle} className="chat-optiwe__icon-avatar" />;
        }
    }
    return null;
}
function _isFbLink(text) {
    if (text.includes("https://www.facebook.com/")) {
        return true;
    }
    return false;
}

function Balloon(props) {
    function displaySocialMediaPost(message) {
        const messageFrom = message.messageFrom;
        if (messageFrom !== "ASSISTANT_NOTE") return <></>;

        const text = message.text;
        const words = text.split(" ");
        const link = words.find((w) => _isFbLink(w));

        if (!link) return <></>;

        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "white",
                }}
            >
                <FacebookEmbed url={link} width={"100%"} />
            </div>
        );
    }

    function getMessageOwnerCustomstyles() {
        if (props.isAgentMessage) {
            return props.customStyles?.bubbles?.messageOwnerAgent;
        } else {
            return props.customStyles?.bubbles?.messageOwnerUser;
        }
    }
    return (
        <div className="balloon-wrapper">
            {props.showOwner && (
                <span
                    style={{
                        ...props.customStyles?.bubbles?.messageOwner,
                        ...getMessageOwnerCustomstyles(),
                    }}
                    className={`chat-optiwe__message-owner ${
                        props.isAgentMessage
                            ? "chat-optiwe__message-owner--agent"
                            : " chat-optiwe__message-owner--user"
                    }`}
                >
                    {props.message.owner}
                </span>
            )}
            <div
                style={props.styles.chatBalloonStyle}
                className={`chat-balloon ${props.styles.chatBalloonClass}`}
            >
                {props.message?.referencedMessage && !props.message.referencedMessage.deletedOn && (
                    <div
                        className="chat-optiwe__referenced-message"
                        onClick={
                            props.referencedClickCb
                                ? () => props.referencedClickCb(props.message.referencedMessage)
                                : null
                        }
                    >
                        <span className="chat-optiwe__referenced-message-title">
                            {props.message.referencedMessage.messageFrom === "ASSISTANT"
                                ? props.message.referencedMessage.assistantUser?.email || ""
                                : props.message.owner}
                        </span>
                        <span>
                            {props.message?.referencedMessage?.messagePayload?.text
                                ? props.message.referencedMessage.messagePayload.text
                                : props.missingReferencedMessageText
                                ? props.missingReferencedMessageText
                                : "-"}
                        </span>
                    </div>
                )}
                <ErrorBoundary>
                    <Linkify properties={{ target: "_blank" }}>
                        {props.message.contentType !== CTE.CONTENT_TYPE.DOCUMENT && (
                            <span className="chat-optiwe__text-message">
                                {props.message.text ? props.message.text : ""}
                                {displaySocialMediaPost(props.message)}
                            </span>
                        )}
                    </Linkify>
                    <ChatWidget {...props} />
                    <span style={{ marginLeft: "auto", fontSize: "0.8em" }}>
                        {props.message.createdOn}
                    </span>
                </ErrorBoundary>
            </div>
        </div>
    );
}

function Message(props) {
    const messageUserType = props.message.userType;
    const currentUser = props.currentUserType;
    let messageType = null;
    const messageTypes = {
        agent: {
            key: "AGENT",
            styles: {
                wrapperClass: "chat-optiwe__container",
                chatBalloonClass: "chat-balloon--optiwe",
                chatBalloonStyle: props.customStyles.bubbles.agentBubble,
            },
        },
        user: {
            key: "USER",
            styles: {
                wrapperClass: "chat-user__container",
                chatBalloonClass: "chat-balloon--user",
                chatBalloonStyle: {},
            },
        },
        server: {
            key: "SERVER",
            styles: {
                wrapperClass: "chat-optiwe__container chat-optiwe__container--server",
                chatBalloonClass: "chat-balloon--server",
                chatBalloonStyle: {},
            },
        },
        note: {
            key: "SERVER",
            styles: {
                wrapperClass: "chat-optiwe__container chat-optiwe__container--note",
                chatBalloonClass: "chat-balloon--server",
                chatBalloonStyle: {},
            },
        },
    };

    const isAgent =
        (messageUserType === CTE.USER_TYPE.AGENT && currentUser === CTE.USER_TYPE.USER) ||
        (messageUserType === CTE.USER_TYPE.USER && currentUser === CTE.USER_TYPE.AGENT);
    if (isAgent) {
        messageType = messageTypes.agent;
    } else {
        messageType = messageTypes.user;
    }

    if (props.message.messageFrom === "SERVER") {
        messageType = messageTypes.server;
    }

    if (props.message.messageFrom === "ASSISTANT_NOTE" && currentUser === CTE.USER_TYPE.AGENT) {
        messageType = messageTypes.note;
    }

    if (props.message.messageFrom === "ASSISTANT_NOTE" && currentUser === CTE.USER_TYPE.USER) {
        messageType = null;
    }

    if (messageType) {
        return (
            <div className={`${messageType.styles.wrapperClass}`} id={"message-" + props.id}>
                {
                    <div
                        className={`chat-message-wrapper ${
                            props.isFullScreen
                                ? "chat-message-wrapper--fullscreen"
                                : "chat-message-wrapper--embedded"
                        }`}
                    >
                        <Avatar
                            isAgentMessage={messageType.key === "AGENT"}
                            styles={props.customStyles}
                            defaultAvatar={props.defaultAvatar}
                        />
                        <Balloon
                            {...props}
                            styles={messageType.styles}
                            isAgentMessage={messageType.key === "AGENT"}
                            showOwner={props.prevMessage?.owner !== props.message?.owner}
                        />
                    </div>
                }
                <ChatWidgetOutside {...props} />
            </div>
        );
    }
    return null;
}
export default Message;
